export default __webpack_public_path__ + "3cd3bb4.png";